<main class="mediumContainer">
    <div [class.reviewRole]="!isSuperuser" class="dashContainer">
        <div class="profile" *ngIf="!this.isMobile">
            <div class="sticky">
                <app-user-info [largeAvatar]="true" [user]="currentUser"></app-user-info>
                <div *ngIf="!this.isMobile" class="gap-10 flex-col pinnedPosts">
                    <app-post-card
                            (action)="loadPostFromSidebar(currentCommunityId)"
                            *ngFor="let post of sidebarPosts; trackBy: trackByPostId"
                            [hidePoll]="true"
                            [post]="post"
                            [reducedContent]="true"
                            [showPinnedBadge]="false"
                    ></app-post-card>
                </div>
            </div>
        </div>
        <div *ngIf="isSuperuser || hasCommunityRole(['full_admin', 'moderator', 'client']) || (community?.allow_members_to_post && hasCommunityRole(['member']))"
             class="createPost">
            <button (click)="newPost()" [style.background-color]="community?.start_discussion_button_bg_color_hex"
                    [style.border-left]="community?.start_discussion_left_border_color_hex? '2px solid ' + community?.start_discussion_left_border_color_hex : 'unset'"
                    [style.color]="this.themeService.getReadableColor(community?.start_discussion_button_bg_color_hex)"
                    class="w-100 discussionBtn"
                    mat-flat-button>
                <ng-container
                        *ngIf="community?.start_discussion_button_text">{{ community?.start_discussion_button_text }}
                </ng-container>
                <ng-container *ngIf="!community?.start_discussion_button_text">Start Discussion</ng-container>
            </button>
        </div>
        <app-dashboard-feed [currentCommunityId]="currentCommunityId" [isMobile]="this.isMobile"
                            [sidebarPosts]="sidebarPosts"/>
        <div class="sidebar" *ngIf="!this.isMobile">
            <div class="sticky rightSide">
                <app-recent-activity *ngIf="community" [community]="community"/>
                <app-points-leaderboard *ngIf="community?.show_points" class="halfSideBar"/>
            </div>
        </div>
    </div>
</main>

